import Httpservice from "@/services/httpservice.js";
import {useToast} from "@/plugins/useToast.js";

const API_URL = import.meta.env.VITE_API_URL;
const {showToast} = useToast();


const getUsuariosResponsaveis = async (pessoaId) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/pessoa/usuario/${pessoaId}/responsaveis`,{});
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar informações do usuario:', error);
        throw error;
    }
};

const getUsuarios = async (pageNumber, pageSize, searchTerm) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/usuario`,{
            params: {
                pageNumber,
                pageSize,
                searchTerm
            }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar processos:', error);
        throw error;
    }
};

const getUsuario = async (id) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/usuario/${id}`,{ });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar usuario', error);
        throw error;
    }
};

const updateUsuario = async (id, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/usuario/${id}`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o usuario', error);
        throw error;
    }
};

const createUsuario = async (values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/usuario`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o usuario', error);
        throw error;
    }
};


const syncColaboradores = async () => {
    try {
      const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/usuario/sync`);

      showToast('Usuários sincronizados com sucesso', {
        title: 'Sucesso',
        type: 'success'
      });

      return response.data;
    } catch (error) {
        showToast('Não foi possível sincronizar os usuários', {
            title: 'Erro',
            type: 'erro'
        });

        throw error;
    }
};


const updateAnalistaResponsavel = async (id) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/usuario/${id}/alterar-analista`, {});
        return response.data;
    } catch (error) {
        console.error('Erro ao alaterar o analista responsavel do usuario', error);
        throw error;
    }
};

const alterarConfiguracoesEmail = async (id, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/usuario/${id}/alterar-senha-email`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o usuario', error);
        throw error;
    }
};

const alterarSenha = async (id, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/usuario/${id}/alterar-senha`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o usuario', error);
        throw error;
    }
};


const testMailSend = async (id, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/usuario/${id}/testar-envio-email`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao enviar e-mail com o usuario', error);
        throw error;
    }
};

const createUsuarioCliente = async (values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/usuario/clientes`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o usuario', error);
        throw error;
    }
};

const getUsuarioCliente = async (id) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/usuario/clientes/${id}`,{ });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar usuario', error);
        throw error;
    }
};



const getUsuarioAccessSettings = async (id) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/usuario/${id}/access-settings`,{ });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar usuario', error);
        throw error;
    }
};


const updateUsuarioCliente = async (id, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/usuario/clientes/${id}`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o usuario', error);
        throw error;
    }
};

const createUsuarioAgente = async (values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/usuario/agentes`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o usuario', error);
        throw error;
    }
};

const getUsuarioAgente = async (id) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/usuario/agentes/${id}`,{ });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar usuario', error);
        throw error;
    }
};

const updateUsuarioAgente = async (id, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/usuario/agentes/${id}`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o usuario', error);
        throw error;
    }
};

const liberarAcao = async (values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/usuario/validate-action`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao liberar ação...', error);
        throw error;
    }
};

const getUsuariosClientesList = async () => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/usuario/clientes`, {
            params: { pageNumber: 1, pageSize: 1000 }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar usuários clientes', error);
        throw error;
    }
};

// Resolve o Business Partner de DHO responsável pela empresa informada (regra de negócio
// fica inteiramente no backend). 204 No Content significa que não há responsável resolvido
// para a empresa e não é um erro — o front deve deixar o campo em branco.
const getBusinessPartnerResponsavel = async (empresaId) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/usuario/business-partners/responsavel`, {
            params: { empresaId }
        });

        if (response.status === 204 || !response.data) {
            return null;
        }

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar o Business Partner responsável pela empresa', error);
        throw error;
    }
};

export default {
    getUsuariosResponsaveis,
    syncColaboradores,
    getUsuarios,
    getUsuario,
    createUsuario,
    updateUsuario,
    updateAnalistaResponsavel,
    alterarConfiguracoesEmail,
    alterarSenha,
    testMailSend,
    createUsuarioCliente,
    getUsuarioCliente,
    getUsuariosClientesList,
    updateUsuarioCliente,
    createUsuarioAgente,
    getUsuarioAgente,
    updateUsuarioAgente,
    getUsuarioAccessSettings,
    liberarAcao,
    getBusinessPartnerResponsavel,
};
